import { render, staticRenderFns } from "./CampaignsListData.vue?vue&type=template&id=53c408d3&lang=pug"
import script from "./CampaignsListData.vue?vue&type=script&lang=js"
export * from "./CampaignsListData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports